import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["processo", "pagamento", "disclosure"]
  static values  = { tela: String }

  connect() {
    this.update()
  }

  telaChanged(event) {
    this.telaValue = event.detail.value
  }

  telaValueChanged() {
    this.update()
  }

  update() {
    this.processoTarget.classList.toggle("hidden", this.telaValue !== "Processo")
    this.pagamentoTarget.classList.toggle("hidden", this.telaValue !== "Pagamento")
    this.expandPainelDaTela()
  }

  expandPainelDaTela() {
    const telaEfetiva = this.telaValue || "Cliente"
    this.disclosureTargets.forEach(disclosure => {
      const content = disclosure.querySelector('[data-ui--disclosure-target="content"]')
      content?.classList.toggle("hidden", disclosure.dataset.titulo !== telaEfetiva)
    })
  }
}
